import { render, staticRenderFns } from "./sbsp-form-list.vue?vue&type=template&id=27cb36b8&scoped=true&"
import script from "./sbsp-form-list.vue?vue&type=script&lang=js&"
export * from "./sbsp-form-list.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-form-list.vue?vue&type=style&index=0&id=27cb36b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb36b8",
  null
  
)

export default component.exports